function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".captions-cls-1{fill:none;}.captions-cls-1,.captions-cls-2,.captions-cls-3{stroke:#fff;}.captions-cls-1,.captions-cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.captions-cls-2,.captions-cls-3{fill:#fff;}.captions-cls-2{stroke-miterlimit:10;stroke-width:1.5px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Calque_2",
  "data-name": "Calque 2"
}, React.createElement("g", {
  id: "Contenu"
}, React.createElement("polygon", {
  className: "captions-cls-1",
  points: "25 9.44 25 1 16.56 1 9.44 1 1 1 1 9.44 1 16.56 1 25 9.44 25 16.56 25 25 25 25 16.56 25 9.44"
}), React.createElement("circle", {
  className: "captions-cls-2",
  cx: 8.6,
  cy: 13,
  r: 0.86
}), React.createElement("circle", {
  className: "captions-cls-2",
  cx: 13,
  cy: 13,
  r: 0.86
}), React.createElement("circle", {
  className: "captions-cls-2",
  cx: 17.4,
  cy: 13,
  r: 0.86
}), React.createElement("polygon", {
  className: "captions-cls-3",
  points: "13 29.36 10.49 25.85 15.51 25.85 13 29.36"
})));

var SvgCaptions = function SvgCaptions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 26 30.37",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCaptions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/captions.3ec29057.svg";
export { ForwardRef as ReactComponent };